import React, {  useEffect } from "react";
import "./../components/Report.css";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";

import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  _replaceAbbreviations,
  _formatBed,
  _isEqual,
  _tranformTagsQuery,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  _activityFL,
} from "../../../../../../shared/helpers/utils";
import PropertyTypePage from "../components/PropertyTypePage";
import {  previousYearPeriod, generatePeriodNames, getCurrentPeriod, getPriorPeriod, getRangeEnd, getRangeStart,} from "../../../exportreport/utils"


const apiURL = process.env.API_ROOT;

let statTypes = [
 {
   key: "sales",
   title: "$4M+ Contracts",
   name: "Luxury Market",
   checkedColor: "#780F9E",
   activitesQuery:
     '(price:[4000000 TO *]) AND event_tags:(condo* co?op* coop* condo*p single?family)',
   default: true,
 },
 {
   key: "four_to_ten",
   title: "$4M to $10M Contracts",
   name: "$4M-$10M Market",
   checkedColor: "#780F9E",
   activitesQuery:
     '(price:[4000000 TO 10000000]) AND event_tags:(condo* co?op* coop* condo*p single?family)',
   default: true,
 },
 {
   key: "ten_plus",
   title: "$10M+ Contracts",
   name: "$10M+ Market",
   checkedColor: "#780F9E",
   activitesQuery:
     '(price:[10000001 TO *]) AND event_tags:(condo* co?op* coop* condo*p single?family)',
   default: true,
 },
];

const statFacet = {
  avg_price: "avg(price)",
  med_price: "percentile(price, 50)",
  sum_price: "sum(price)",
  by_borough: {
    type: "terms",
    field: "borough",
    facet: {
      avg_price: "avg(price)",
      med_price: "percentile(price, 50)",
    },
  },
  ppsf: {
    type: "query",
    q: "sq_ft:[300 TO 20000]",
    facet: {
      avg: "avg(div(price, sq_ft))",
      med: "percentile(div(price, sq_ft), 50)",
    },
  },
  price_change: {
    type: "query",
    q: "price_change_amount:*",
    facet: {
      avg: "avg(price_change_amount)",
      percent: "avg(price_change_percent)",
      sum: "sum(price_change_amount)",
    },
  },
  dom: {
    type: "query",
    q: "days_on_market:[3 TO 720]",
    facet: {
      avg: "avg(days_on_market)",
      med: "percentile(days_on_market, 50)",
    },
  },
  under_one: {
    type: "query",
    q: "price:[10000 TO 999999]",
  },
  one_to_two: {
    type: "query",
    q: "price:[1000000 TO 1999999]",
  },
  two_to_four: {
    type: "query",
    q: "price:[2000000 TO 3999999]",
  },
  four_to_ten: {
    type: "query",
    q: "price:[4000000 TO 9999999]",
  },
  ten_plus: {
    type: "query",
    q: "price:[10000000 TO 350000000]",
  },
};

const Layout = (props) => {
  const {
    fetchInProgress,
    setFetchInProgress,
    user,
    reportLoaded,
    setReportLoaded,
    reportData,
    setReportData,
    searchTags,
    summarizeGeographies,
    customDate,
    submit,
    setSubmit,
    color,
    reportHeader,
    logo,
    formValues
  } = props;

  const { dateOptions } = customDate;
  const currentPeriod = getCurrentPeriod(dateOptions)
  const priorPeriod = getPriorPeriod(dateOptions)

  const priorYearPeriod = priorPeriod;
  
  const rangeEnd = getRangeEnd(dateOptions);
  console.log(dateOptions, rangeEnd);
  const rangeStart = getRangeStart;
  const gap = dateOptions.gap;
  const currentPeriodName = generatePeriodNames(dateOptions).currentPeriod;
  const priorYearPeriodName = generatePeriodNames(dateOptions).priorYearPeriod;
  useEffect(() => {
    if (!reportData && !fetchInProgress && submit) {
      loadData();
      setSubmit(false)
    }
  }, [submit]);

  const dataFacet = {
    contract_signed: {
      type: "query",
      q: "topic:listings AND event_tags:contract-signed AND -event_tags:rent AND -event_tags:*commercial*",
      facet: {
        current_period: {
          type: "query",
          q: `time:${currentPeriod}`,
          facet: statFacet,
        },
        prior_period: {
          type: "query",
          q: `time:${priorPeriod}`,
          facet: statFacet,
        },
        prior_year_period: {
          type: "query",
          q: `time:${priorYearPeriod}`,
          facet: statFacet,
        },
        chart: {
          range: {
            field: "time",
            start: rangeStart,
            end: rangeEnd,
            gap: gap,
            facet: {
              dom: {
                type: "query",
                q: "days_on_market:[3 TO 720]",
                facet: {
                  avg: "avg(days_on_market)",
                  med: "percentile(days_on_market, 50)",
                },
              },
              ppsf: {
                type: "query",
                q: "sq_ft:[300 TO 20000]",
                facet: {
                  avg: "avg(div(price, sq_ft))",
                  med: "percentile(div(price, sq_ft), 50)",
                },
              },
            },
          },
        },
      },
    },
    new_listings: {
      type: "query",
      q: "topic:listings AND event_tags:just-listed AND -event_tags:rent AND -event_tags:*commercial*",
      facet: {
        current_period: {
          type: "query",
          q: `time:${currentPeriod}`,
          facet: statFacet,
        },
        prior_period: {
          type: "query",
          q: `time:${priorPeriod}`,
          facet: statFacet,
        },
        prior_year_period: {
          type: "query",
          q: `time:${priorYearPeriod}`,
          facet: statFacet,
        },
        chart: {
          range: {
            field: "time",
            start: rangeStart,
            end: rangeEnd,
            gap: gap,
            facet: {
              med_price: "avg(price)",
              med_price: "percentile(price, 50)",
              sum_price: "sum(price)",
              ppsf: {
                type: "query",
                q: "sq_ft:[300 TO 20000]",
                facet: {
                  avg: "avg(div(price, sq_ft))",
                  med: "percentile(div(price, sq_ft), 50)",
                },
              },
            },
          },
        },
      },
    },
    recorded_sold: {
      type: "query",
      q: "topic:transactions AND event_tags:recorded-sale AND -event_tags:*commercial* AND  -event_tags:property-type_parking-space AND -event_tags:property-type_storage-room AND -event_tags:parcels_bulk-sale",
      facet: {
        current_period: {
          type: "query",
          q: `time:${currentPeriod}`,
          facet: statFacet,
        },
        prior_period: {
          type: "query",
          q: `time:${priorPeriod}`,
          facet: statFacet,
        },
        prior_year_period: {
          type: "query",
          q: `time:${priorYearPeriod}`,
          facet: statFacet,
        },
        chart: {
          range: {
            field: "time",
            start: rangeStart,
            end: rangeEnd,
            gap: gap,
            facet: {
              med_price: "avg(price)",
              med_price: "percentile(price, 50)",
              sum_price: "sum(price)",
              ppsf: {
                type: "query",
                q: "sq_ft:[300 TO 20000]",
                facet: {
                  avg: "avg(div(price, sq_ft))",
                  med: "percentile(div(price, sq_ft), 50)",
                },
              },
            },
          },
        },
      },
    },
  };

  const loadData = async () => {
    let q = "*:*";
    let locQuery = _tranformTagsQuery(searchTags);

    if (locQuery) {
      q = locQuery;
    }

    const defaultQ = getCohortQuery(user, true);
    const fq = [
      ..._activityFQ.slice(),
      ...[
        `{!join from=alternate_keys fromIndex=we3-buildings to=building}${defaultQ}`,
      ],
    ];
    setFetchInProgress(true);
    let facet = {};
    statTypes.map((item) => {
      facet[item.key] = {
        type: "query",
        q: item.activitesQuery,
        facet: dataFacet,
      };
    });
    let axiosData = {
      url: apiURL + "/query/we3-activities-3?cache_time=1440&always-cache=true",
      method: "post",
      query: {
        q: q,
        fq: fq,
        wt: "json",
        rows: 0,
        "json.facet": facet,
      },
    };

    let res = await _axiosCall(axiosData)
      .then(async (res) => {
        if (res && res.facets) {
          setFetchInProgress(false);
          setReportLoaded(true);
          setSubmit(false);
          console.log(res);
          setReportData(res);
        }
        return res;
      })
      .catch((error) => {
        console.log("error: " + error);
      });
  };
    
    if (!reportData) return null;
    return (
      <>
      {statTypes.map(type => {
        
        return  <PropertyTypePage type={type}    {...props}
        summarizeGeographies={summarizeGeographies} 
        priorYearPeriodName={priorYearPeriodName} 
        currentPeriodName={currentPeriodName}/>
        
      })}
      </>
    )
};

export default Layout;
